import { useEffect, useState } from "react";

/**
 * 返回页面滚动进度（0 - 100）与是否已经滚动到一定高度。
 */
export function useScrollState(threshold = 240) {
  const [progress, setProgress] = useState(0);
  const [passed, setPassed] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const scrollTop = window.scrollY;
      const height = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(height > 0 ? Math.min(100, Math.round((scrollTop / height) * 100)) : 0);
      setPassed(scrollTop > threshold);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);

  return { progress, passed };
}